export const LOADER_STATUS = "boilderplate/PREPAREGSTR9C/LOADER_STATUS";
export const UPLOAD_HISTORY_TABLE_DATA =
  "boilderplate/PREPAREGSTR9C/UPLOAD_HISTORY_TABLE_DATA";
export const PREPARE_TABLE_DATA =
  "boilderplate/PREPAREGSTR9C/PREPARE_TABLE_DATA";
